import React, { Component } from 'react';
import BGVideo from '../background-video/background-video';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './home.css';

class Home extends Component {
  render() {
    return (
      <div id="home">
        <ReactCSSTransitionGroup
          transitionAppear={true}
          transitionAppearTimeout={600}
          transitionEnterTimeout={600}
          transitionLeaveTimeout={200}
          transitionName={'SlideUp'}
        >
          <BGVideo />
          <div className="homeboxContainer">
            <div className="homebox">
              <div className="content">
                <h3>Here at Surfside Solutions, our aim is to help local businesses and communities do <i>IT</i> better!</h3>

                <p>First established in 1998 doing both hardware (PC Builds) and software installations, the focus of Surfside Solutions in the millenium has focused more and more onto function rich websites and bespoke apps which help local businesses in and around the Mourne area to develop and grow their online profile. Since 2014 we have only built responsive websites which work across all devices and platforms with web browsers. The need for this decision was emphasised in November 2016 when it was announced by <a href="http://gs.statcounter.com/platform-market-share/desktop-mobile-tablet">statcounter Globalstats</a> that Mobile and tablet devices accounted for more than half of the worldwide internet usage!</p>

                <p>We aim to achieve this through our expertise in Website Design and Development, using modern standards and frameworks (Angular4, React, SASS, HTML5) as well as using modern techniques for enhanced SEO (Search Engine Optimisation) and Social Media Marketing to improve our Clients presence on the web.</p>
            </div>
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/home.js